import { render, staticRenderFns } from "./DrawingIndex.vue?vue&type=template&id=32c97c41&scoped=true&"
import script from "./DrawingIndex.vue?vue&type=script&lang=js&"
export * from "./DrawingIndex.vue?vue&type=script&lang=js&"
import style0 from "./DrawingIndex.vue?vue&type=style&index=0&id=32c97c41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c97c41",
  null
  
)

export default component.exports